<template>
  <card :class="{ 'highlighted-card': highlighted }">
    <div class="row">
      <div class="col-8 mt-2 padding p-0 ">
        <div class="row">
          <div class="col-2">
            <div :class="'icon icon-shape text-white rounded-circle shadow bg-gradient-' + color(index)">
              <i class="ni ni-money-coins"></i>
            </div>
          </div>
          <div class="col-10 pl-4">
            <h4 class="card-title text-uppercase text-muted mb-0">
              <span v-if="showMeta(index)">Meta</span>
              {{ translateGroupName(index) }}
            </h4>
            <span class="h2 font-weight-bold mb-0">
              {{ parseFloat(categoryGoal).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
            </span>
          </div>
        </div>
        <p class="mt-3 mb-0 text-sm col-12 p-0">
          Meta Realizada:
          {{ realizedGoal.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
          <br />
          <span class="text-success mr-2" v-if="admin">
            <strong>
              <span>
                Meta Realizada Total
                {{ translateGroupName(index).charAt(0).toUpperCase() + translateGroupName(index).slice(1).toLowerCase()}}:
                {{ (realizedTotalGoal || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" }) }}
              </span>
            </strong>
          </span>
        </p>
      </div>
      <div class="col-4 pb-3 px-0 m-0 chart">
        <doughnut-chart class="chart p-0 m-0" :chartData="chartData" ref="doughnut-chart" />
      </div>
    </div>
  </card>
</template>

<script>
import DoughnutChart from "@/components/Charts/DoughnutChart.vue";

export default {
  props: {
    index: { required: true },
    grupo: { required: true },
    goals: { required: true },
    strategicGoals: { required: true },
    realizedFinancialGoal: { required: true },
    realizedStrategicGoal: { required: true },
    allSalesValue: { required: true },
    realizedSales: { required: true },
    strategicTotalVegetal: { required: true },
    totalVegetalSupplier: { required: true },
    totalGoalsPurchaseSupplier: { required: true },
    realizedPurchaseSupplierGoal: {required: true},
    highlighted: { default: false },
    admin: { default: false },
  },
  components: {
    DoughnutChart,
  },
  computed: {
    chartData() {
      return [
        { label: "Meta realizada", value: this.realizedGoal },
        { label: "Meta estipulada", value: this.admin ? (this.grupo || 0) : this.categoryGoal },
      ];
    },
    salesmanSales() {
      return (this.goals && this.goals[this.index] && this.goals[this.index].salesman_sales) || 0;
    },
    salesmanGoal() {
      return (this.goals && this.goals[this.index] && this.goals[this.index].salesman_goal) || 0;
    },
    realizedGoal() {
      if (this.index === 'meta_fornecedor')  return this.realizedPurchaseSupplierGoal || 0;
      if (this.index === 'meta_financeira')  return this.realizedFinancialGoal || 0;
      if (this.index === 'meta_estrategica') return this.realizedStrategicGoal || 0;
      if (this.index.startsWith('ESTRATÉGICO')) return this.realizedStrategicGoal || 0; 
           
      return this.salesmanSales;
    },
    realizedTotalGoal() {
      if (this.index === 'meta_financeira')  return this.allSalesValue || 0;
      if (this.index === 'meta_estrategica') return this.strategicTotalVegetal || 0;
      if (this.index === 'meta_fornecedor')  return this.totalVegetalSupplier || 0;

      const group = this.translateGroupName(this.index);
      return (this.realizedSales[group] && this.realizedSales[group].salesman_sales) || 0;
    },
    summarizedSalesmanGoal() {
      return Object.values(this.goals).reduce(
        (sum, current) => sum + (current.salesman_goal || 0),
        0
      );
    },
    summarizedSalesmanStrategicGoal() {
      return Object.values(this.strategicGoals).reduce(
        (sum, current) => sum + (current.salesman_goal || 0),
        0
      );
    },
    categoryGoal() {
      if (this.index === 'meta_fornecedor') return this.totalGoalsPurchaseSupplier || 0;
      if (this.admin) return this.grupo || 0;
      if (this.index === 'meta_financeira')       return this.summarizedSalesmanGoal;
      if (this.index === 'meta_estrategica')      return this.summarizedSalesmanStrategicGoal;
      if (this.index.match(/estrat[ée]gic[oa]/i)) return this.grupo || 0;

      return this.salesmanGoal;
    },
  },
  methods: {
    translateGroupName(name) {
      const groupNames = {
        meta_financeira: this.admin ? "VEGETAL" : "FINANCEIRA",
        meta_estrategica: "ESTRATÉGICA",
        meta_fornecedor: "FORNECEDOR",
      };

      return groupNames[name] || name;
    },

    color(type) {
      switch (type) {
        case "NUTRIÇÃO": return "yellow";
        case "AGROQUÍMICOS": return "grey";
        case "SEMENTES": return "blue";
        case "OUTROS": return "red";
        case "ESTRATÉGICO NUTRIÇÃO": return "yellow";
        case "ESTRATÉGICO AGROQUÍMICOS": return "grey";
        case "ESTRATÉGICO SEMENTES": return "blue";
        case "ESTRATÉGICO OUTROS": return "red";
        default: return "green" ;
      }
    },
    showMeta(index) {
      return [ 'meta_financeira','meta_estrategica', 'meta_fornecedor'].includes(index);
    }
  }
};
</script>

<style scoped>
.chart {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 160px;
  width: 300px;
}

.highlighted-card {
  border: 3px solid #2dce89;
}

@media (max-width: 768px) {
  .padding {
    padding: 20px !important;
  }

  .chart {
    height: 150px;
    width: 320px;
  }
}
</style>
